<template>
  <div class="notices">
    <div class="notice addGroups">
      <div class="noticeHead">
        {{title}}
      </div>
      <div class="noticeClose" @click="closeNotice"></div>
      <div class="addBox">
        <p>
          <span>小组名称：</span>
          <input type="text" name="" id="" placeholder="请输入小组名称" v-model="teamName">
        </p>
        <div class="stuContent">
          <div class="leftContent">
            <form class="searchStudents" @submit.prevent="search($event)">
              <input type="text" name="" id="" placeholder="请输入学生名字" v-model.trim="keywords">
              <!-- <img src="../../assets/img/search.png" alt="" @click="search($event)" v-if="keywords.trim().length=0"> -->
              <span :class="{'clearBtn': !btnShow}" @click="clearInput($event)"></span>
              <span :class="{'searchBtn': btnShow}"  @click="search($event)"></span>
            </form>
            <div class="groups">
              <p v-show="noStudent" class="noStu">您搜索的学生不存在~</p>
              <ul v-for="(item,index) in selectStudents" :key="index">
                <span>{{item.title}}
                  <em>({{item.data.length}})</em>
                </span>
                <li v-for="(sitem,sIndex) in item.data" :key="sIndex">
                  <span :class="{'active': sitem.checked}" @click="stuToggle(sitem)">{{sitem.userName}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="rightContent" v-if="identify == 'addGroup'">
            <div class="groups">
              <ul>
                <span>已选学生
                  <em>({{selCount}})</em>
                </span>
                <ul>
                  <li v-for="(item,index) in selectStu" :key="index">
                    <span>{{item.userName}}</span>
                    <em @click="deleteAddStu(item,index)"></em>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
          <div class="rightContent" v-if="identify == 'edit'">
            <div class="groups">
              <ul>
                <span>已选学生
                  <em>({{editStu.length}})</em>
                </span>
                <ul>
                  <li v-for="(sitem,sIndex) in editStu" :key="sIndex">
                    <span>{{sitem.userName}}</span>
                    <em @click="deleteStu(sitem,sIndex)"></em>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="noticeBottom">
        <button class="sure" @click="ensure">确定</button>
        <button class="cancel" @click="abolish">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "./../../fetch";
export default {
  data() {
    return {
      isConfirm: false,
      title: "",
      changeStyle: "",
      keywords: "",
      isSearch: false,
      selectStu: [],
      selCount: 0,
      teamName: "",
      classid: "",
      stustr: "",
      identify: "",
      checked: false,
      editGroups: [],
      selectStudents: [], // 学生列表
      noStudent: false,
      editStu: [],
      isSuccess: false,
      editStuStr: [],
      btnShow: true
      // students: [],  // 原数据
      // students1: [],  // 显示学生列表
      // students2: [],   
      // EditGroup: []
    };
  },
  props: ["params"],
  created() {
    this.title = this.params.noticeTitle;
    this.classid = this.params.classid;
    
    this.identify = this.params.identify;
    // 新建小组的时候
    if (this.identify == "addGroup") {
      this.addTeam = this.params.addGroups;
      console.log(this.addTeam)
      this.addTeam.map(item => {
        item.data.map(sItem => {
          sItem.checked = false;
        });
      });
      this.selectStudents = this.params.addGroups;
    }
    // 编辑的时候
    if (this.identify == "edit") {
      this.selectStudents = this.params.allGroups; // 编辑时候左边显示除了本身之外的所有小组
      
      this.editGroups = this.params.editGroups; // 右边显示本身小组
      let arr = this.editGroups.data //定义新变量接收本身小组数据
      this.editStu.push(arr)
      let newArr = []
      newArr.push(arr)
      this.editStu = [].concat.apply([],newArr)
      console.log(this.editStu, "2");
      this.teamName = this.editGroups.title;
      this.teamId = this.editGroups.data[0].teamId
      // 当用户不选择学生时候直接修改分组，此时传入的学生di即为该分组本身的学生id
      this.getStuStr()
    }
  },

  methods: {
    closeNotice() {
      this.$emit("isConfirm", this.isConfirm);
    },
    stuToggle(sitem) {
      sitem.checked = !sitem.checked;
      this.checked = sitem.checked;
      if (this.identify == "edit") {
        this.editStu.push(sitem);
        let editArr = this.editStu;
        this.editStu = Array.from(new Set(editArr));
        let newEdit = this.editStu;
        for (let index = 0; index < newEdit.length; index++) {
          const element = newEdit[index];
          if (!element.checked) {
            newEdit.splice(index, 1);
          }
        }
        
        // 当用户编辑时候选择学生时候，调用函数
        this.getStuStr()
      }

      // 新建学生的时候
      this.selectStu.push(sitem);
      let newArr = this.selectStu;
      this.selectStu = Array.from(new Set(newArr)); // 去除重复选择
      for (let j = 0; j < this.selectStu.length; j++) {
        const item = this.selectStu[j];
        if (!item.checked) {
          this.selectStu.splice(j, 1);
        }
      }
      this.selCount = this.selectStu.length;
      //   获取选择的学生id
      let newStu = this.selectStu;
      let stuArr = [];
      for (let i = 0; i < newStu.length; i++) {
        const item = newStu[i];
        stuArr.push(item.userId);
      }
      this.stustr = stuArr.join(",");
    },

    // 获取学生的id，进行拼接
    getStuStr() {
      let editStudents = this.editStu;
      let editStudentsArr = [];
      for (let i = 0; i < editStudents.length; i++) {
        const item = editStudents[i];
        editStudentsArr.push(item.userId);
      }
      this.editStuStr = editStudentsArr.join(",");
      console.log(this.editStuStr, "edit");
    },

    // 搜索学生
    search() {
      if (!this.keywords) {
        this.noStudent = false;
        this.selectStudents = this.params.allGroups
        return false;
      }
      let newList = [];
      this.btnShow = false
      for (let i = 0; i < this.selectStudents.length; i++) {
        let stuData = this.selectStudents[i];
        let item = this.selectStudents[i].data;
        let arr = [];
        for (let j = 0; j < item.length; j++) {
          if (item[j].userName.indexOf(this.keywords) > -1) {
            arr.push(item[j]);
            newList.push({
              checked: stuData.checked,
              count: stuData.count,
              data: arr,
              selNum: stuData.selNum,
              teamShow: stuData.teamShow,
              title: stuData.title
            });
          }
        }
      }
      this.selectStudents = newList;
      if(this.selectStudents.length == 0) {
        this.noStudent = true;
      }
      console.log(this.selectStudents)
    },

    // 清空搜索，显示学生列表
    clearInput() {
      this.keywords = "";
      this.noStudent = false;
      this.btnShow = true
      this.selectStudents = this.params.addGroups;
      if (this.identify == "edit") {
      this.selectStudents = this.params.allGroups;
      }
    },

    // 删除已选学生
    deleteStu(sitem, sIndex) {
      this.editStu.splice(sIndex, 1);
      sitem.checked = false;
      this.getStuStr()
    },
    deleteAddStu(item, index) {
      this.selectStu.splice(index, 1);
      item.checked = false;
      this.selCount = this.selectStu.length;
      console.log()
    },

    // 取消选择
    abolish() {
      this.$emit("isConfirm");
    },

    // 确定
    ensure() {
      let identify = this.identify;
      if (this.teamName == "") {
        this.$toast("请输入分组名称", "error");
        return false;
      }
      
      switch (identify) {
        case "addGroup":
          if (this.teamName == "未分组") {
            this.$toast("不能新建未分组");
            return false;
          }
          if (!this.checked) {
            this.$toast("请至少选择一个学生", "error");
            return false;
          }
          for (let i = 0; i < this.addTeam.length; i++) {
            const item = this.addTeam[i];
            if (this.teamName == item.title) {
              this.$toast("该小组名称已存在，请重新输入小组名称");
              return false;
            }
          }
          let params = {
            teamname: this.teamName,
            classid: this.classid,
            stustr: this.stustr
          };
          fetch.addTeam(params).then(res => {
            if (!res.data) {
              return false;
            }
            this.isSuccess = true
            this.$emit("isConfirm", this.isSuccess);
          });
          break;
        case "edit":
          let params1 = {
            teamid: this.teamId,
            teamname: this.teamName,
            classid: this.classid,
            stustr: this.editStuStr
          };
          fetch.ediTeam(params1).then(res => {
            if (!res) {
              return false;
            }
            this.isSuccess = true
            this.$emit("isConfirm", this.isSuccess);
          });
          break;
      }
    },
    
  }
};
</script>




// WEBPACK FOOTER //
// addGroups.vue?9157a874